// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","276":"tag","343":"onboarding"}[chunkId] + "." + {"177":"727a04dc","276":"05c7b063","343":"cf539b74"}[chunkId] + ".css";
};